import { Component, OnInit } from '@angular/core';
import { DataStateEnum } from 'src/app/enumeration/dataState.enum';
import { Bien } from 'src/app/models/Bien';
import { Programme } from 'src/app/models/Programme';
import { Publication } from 'src/app/models/Publication';
import { biTypologieDto } from 'src/app/models/biTypologieDto';
import { opeFgDto } from 'src/app/models/opeFgDto';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';
import { SearchOpeCriteria } from 'src/app/models/SearchOpeCriteria';
import { OpeDetail } from 'src/app/models/OpeDetail';
import { vignetteOpe } from 'src/app/models/vignetteOpe';
import { LotBynumOpe } from 'src/app/models/LotBynumOpe';
import { sharePitSevices } from 'src/app/services/pitupload/sharePit.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { OpePit } from 'src/app/models/OpePit';
import { PituploadService } from 'src/app/services/pitupload/pitupload.service';
import { vignetteOpePit } from 'src/app/models/vignetteOpePit';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ProgressBarModule } from 'primeng/progressbar';
import { MapSinglePitComponent } from 'src/app/global-composants/map-single-pit/map-single-pit.component';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from "primeng/button";
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AngularEditorModule } from '@kolkov/angular-editor';

@Component({
  selector: 'app-pitupload-programme-presentation',
  templateUrl: './pitupload-programme-presentation.component.html',
  imports: [CommonModule, FormsModule, ProgressBarModule, MapSinglePitComponent, ToastModule, DialogModule,ButtonModule,CommonModule,ConfirmDialogModule,AngularEditorModule],
  styleUrls: ['./pitupload-programme-presentation.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class PituploadProgrammePresentationComponent implements OnInit {

  publication!: Publication[];
  programme!: Programme;
  prixstart!: number;
  readonly DataStateEnum = DataStateEnum;
  listebien: Bien[] = [];
  lisprix!: number[];
  prixlist!: number;
  count!: number;
  textpublication = '';
  textpublicationEdit = '';
  pageSize = 1;
  pageIndex = 0;
  criteriaSearch: SearchOpeCriteria;
  nbmoisLivraison: number[] = [12];
  programmeseled!: OpePit;
  nbpiece: number[] = [2, 4];
  myfirestlist!: Programme[];
  typeAbrgd!: biTypologieDto[];
  statut!: string[];
  minNo!: string;
  maxNo!: string;
  descriptionStatut!: string;
  dateprevLivraison!: opeFgDto;
  datepre!: string;
  quarter!: number;
  yearpre!: string;
  listOpe!: Programme[];
  prixtodisplay!: string;
  opedetail!: OpeDetail;
  datafrom!: OpeDetail;
  moispre!: string;
  jourspre!: string;
  date!: string;
  minTypeLot!: string;
  maxTypeLot!: string;
  vignettedetails!: vignetteOpe;
  urlImageVig = '';
  NewListLot: LotBynumOpe[] = [];
  loading!: boolean;
  imageLoaded = false;
  showMenuVig = false;
  uploadVigDialog = false;
  editprezDialog = false;
  previewUrl: string | ArrayBuffer | null = "";
  visiteVirtuelle!: string | null;
  urlLogement!: string | null;
  editUrlsDialog = false;
  blobImageToUpload = "";
  fileUploader!: File;
  vigPrincipal!: vignetteOpePit;
  imagesFiltre: vignetteOpePit[] = [];

  constructor(private confirmationService: ConfirmationService, public pitService: PituploadService, public messageService: MessageService, public sharePitSevices: sharePitSevices,
    public share: shareOpeSevices) {
    this.criteriaSearch = new SearchOpeCriteria();
  }

  ngOnInit() {

    this.share.showprogressbar = true;
    this.programmeseled = this.sharePitSevices.pituploadSelectedOpe;
    if (this.programmeseled) {
      this.getDataBienetPUB(this.programmeseled.numOpe);
      this.getUrlVignette_img(this.programmeseled.numOpe);
      this.visiteVirtuelle = this.programmeseled.visiteVirtuelle;
      this.urlLogement = this.programmeseled.landingPage;
      this.share.showprogressbar = false;
      this.sharePitSevices.mediaArrayPit$.subscribe(data => {
        this.imagesFiltre = data.filter(item => item.position == 1);
      });
    }
  }

  getDataBienetPUB(numOpe: number) {
    this.textpublication = "";
    this.pitService.getPublicationOpe(numOpe).subscribe(data => {

      this.publication = data;
      //filter sur la langue Fr pour le moment
      this.publication = this.publication.filter(entry => entry.langue = 'FR');
      //sorted by numlinge
      this.publication = this.sortArraybyObjValue(this.publication, 'numLigne');
      this.publication.forEach(data => {
        this.textpublication += data.libelle;
      })
    },
      error => {
        this.share.showprogressbar = false;
        // console.log(error);
      })

  }



  // supprimer les duplications des publications via un param 
  //we will move this to package utils
  removeDuplicates(myArray: any[], Prop: string) {

    return myArray.filter((obj: any, pos: number, arr: any[]) => {
      return arr.map((mapObj: any) => mapObj[Prop as keyof typeof mapObj]).indexOf(obj[Prop as keyof typeof obj]) === pos;
    });
  }

  sortArraybyObjValue = (arr: any[], value: string | number) => {
    //return an array with object sorted by value 
    //sort by object key that matches the value 
    //we will move this to package utils
    return arr.sort((a, b) => {
      return a[value] - b[value];
      //return a[value] < b[value] ? -1 : a[value] > b[value] ? 1: 0
    })
  }

  getQuarter() {

    if (this.datepre === '01' || this.datepre === '02' || this.datepre === '03') {
      return 1
    }
    else if (this.datepre === '04' || this.datepre === '05' || this.datepre === '06') {
      return 2
    }
    else if (this.datepre === '07' || this.datepre === '08' || this.datepre === '09') {
      return 3
    }
    else {
      return 4
    }
  }

  // move to package util
  removeNull(array: any[]) {
    array.forEach((v, i) => {
      if (v == '0' || v == null) {
        array.shift();
      } else {
        array.splice(v - 1, 1);
      }
    })
  }

  showprogressbar: boolean = false;
  getUrlVignette_img(data: number) {
    this.showprogressbar = true;
    this.pitService.getFirVignetteBynumOpe(data).subscribe(res => {
      this.sharePitSevices.sendMediaArrayPit(res);
      this.imagesFiltre = res.filter(item => item.position == 1);
      if (this.imagesFiltre.length == 0) {
        this.urlImageVig = "assets/images/placeholder-vignette-all.png";
      } else {
        this.urlImageVig = "data:image/" + this.imagesFiltre[0].eiBinPit.btype + ";base64," + this.imagesFiltre[0].eiBinPit.bblob;
      }
      this.showprogressbar = false;
    })
  }

  editVig() {
    this.uploadVigDialog = true;
  }
  deleteGalItem(element: vignetteOpePit) {
    let objDel = structuredClone(element);
    delete objDel.showActions;
    delete objDel.imageLoaded;
    objDel.eiBinPit.bblob = "";
    this.share.showprogressbar = true;
    this.pitService.deleteMedia(objDel).subscribe(res => {
      this.messageService.add({ severity: "warning", summary: "Photo principale ", detail: "suppression avec succès" });
      this.pitService.getFirVignetteBynumOpe(element.numOpe).subscribe(res => {
        this.sharePitSevices.sendMediaArrayPit(res);
        this.imagesFiltre = res.filter(item => item.position == 1);
        if (this.imagesFiltre.length == 0) {
          this.urlImageVig = "assets/images/placeholder-vignette-all.png";
        } else {
          this.urlImageVig = "data:image/" + this.imagesFiltre[0].eiBinPit.btype + ";base64," + this.imagesFiltre[0].eiBinPit.bblob;
        }
        this.share.showprogressbar = false;
      })
    },
      error => {
        this.share.showprogressbar = false;
        // console.log(error);
      })
  }

  confirm2() {
    let element = this.imagesFiltre[0];
    this.confirmationService.confirm({
      header: 'Confirmation',
      message: 'Valider la suppression ?',
      acceptLabel: 'Oui',
      accept: () => {
        //this.messageService.add({ severity: 'success', summary : "Suppression", detail: "Le document est supprimé avec succès" });
        this.deleteGalItem(element);
      },
      rejectLabel: 'Non'
    });
  }

  editPrez() {
    this.textpublicationEdit = this.textpublication;
    this.editprezDialog = true;
  }

  editUrls() {
    this.editUrlsDialog = true;
  }

  publishExtranet() {
    this.share.showprogressbar = true;
    let msgNotif = "Publication Extranet activée";
    let severity = "success";
    if (this.programmeseled.pubExt !== 1) this.programmeseled.pubExt = 1;
    else {
      this.programmeseled.pubExt = 0;
      severity = "success";
      msgNotif = "Publication Extranet désactivée";
    }
    this.pitService.updatePubPit(this.programmeseled)
      .subscribe({
        next: (data: OpePit) => {
          this.messageService.add({ severity: severity, summary: "Modification de l'opération " + this.programmeseled.numOpe, detail: msgNotif });
          this.programmeseled = data;
          this.share.showprogressbar = false;
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: "Erreur " + err.status, detail: err.message });
          this.share.showprogressbar = false;
          // console.log(e);
        }
      })
  }

  publishWeb() {
    this.share.showprogressbar = true;
    let msgNotif = "Publication Web activée";
    let severity = "success";
    if (this.programmeseled.publication !== 1) this.programmeseled.publication = 1;
    else {
      this.programmeseled.publication = 0;
      severity = "success";
      msgNotif = "Publication Web désactivée";
    }
    this.pitService.updatePubPit(this.programmeseled)
      .subscribe({
        next: (data: OpePit) => {
          this.messageService.add({ severity: severity, summary: "Modification de l'opération " + this.programmeseled.numOpe, detail: msgNotif });
          this.programmeseled = data;
          this.share.showprogressbar = false;
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: "Erreur " + err.status, detail: err.message });
          this.share.showprogressbar = false;
          // console.log(e);
        }
      })
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    this.handleFile(file);
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer?.files.length) {
      const file = event.dataTransfer.files[0];
      this.handleFile(file);
    }
  }

  handleFile(file: File) {
    if (file && file.type.startsWith('image/')) {
      this.fileUploader = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.previewUrl = reader.result;
      }
      reader.readAsDataURL(file);

      // send to backend 
      //this.messageService.add({ severity: 'success', summary: "Upload", detail: "Publication Web désactivée" });
    } else {
      this.messageService.add({ severity: 'error', summary: "Le fichier n'est pas accepté ", detail: file.type });
    }
  }

  annulerUploadVig() {
    this.previewUrl = null;
    this.share.showprogressbar = false;
  }

  luanchUploadVig() {
    this.share.showprogressbar = true;
    this.blobImageToUpload = (this.previewUrl as string).split(',')[1];
    let objectCreate: any = this.getObjectVigFirst();
    this.pitService.updateMedia(objectCreate).subscribe({
      next: (res) => {
        this.messageService.add({ severity: "success", summary: "Photo principale ", detail: "Modification avec succès" });
        this.imagesFiltre = [res];
        this.urlImageVig = "data:image/" + res.eiBinPit.btype + ";base64," + res.eiBinPit.bblob;
        this.uploadVigDialog = false;
        this.share.showprogressbar = false;
        this.previewUrl = null;
      },
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: "Erreur " + err.status, detail: err.message });
        this.share.showprogressbar = false;
      }
    })
  }

  getObjectVigFirst() {
    let objUpdate: any;
    if (this.imagesFiltre.length == 1) {
      objUpdate = structuredClone(this.imagesFiltre[0]);
      objUpdate.eiBinPit.btype = this.fileUploader.type.split('/')[1];
      objUpdate.eiBinPit.bblob = this.blobImageToUpload;
      objUpdate.eiBinPit.btaille = this.fileUploader.size;
      objUpdate.eiBinPit.bnom = this.fileUploader.name;
      objUpdate.dm = new Date;
    } else if (this.imagesFiltre.length == 0) {
      objUpdate = {
        code: null,
        eiBinPit: {
          btype: this.fileUploader.type.split('/')[1],
          bblob: this.blobImageToUpload,
          btaille: this.fileUploader.size,
          bnom: this.fileUploader.name,
          bcode: null
        },
        numOpe: this.sharePitSevices.pituploadSelectedOpe.numOpe,
        langue: 'FR',
        urlDoc: this.fileUploader.name,
        urlImage: this.fileUploader.name,
        commentaire: "",
        typeDoc: 146,
        position: 1,
        dc: new Date,
        dm: new Date,
        user: this.sharePitSevices.user,
        nomFichier: this.fileUploader.name
      }
    }
    return objUpdate;
  }

  annulerPrezText() {
    this.textpublicationEdit = this.textpublication;
    this.editprezDialog = false;
  }

  savePrezText() {
    let ppePublUpdate = {
      libelle: this.textpublicationEdit,
      numOpe: this.programmeseled.numOpe,
      langue: "FR",
      dc: new Date,
      dm: new Date,
      user: this.sharePitSevices.user
    };
    this.share.showprogressbar = true;
    this.pitService.updatePublication(ppePublUpdate).subscribe(
      {
        next: (res) => {
          this.messageService.add({ severity: "success", summary: "Desciption ", detail: "Modification avec succès" });
          this.getDataBienetPUB(this.programmeseled.numOpe);
          this.editprezDialog = false;
          this.share.showprogressbar = false;
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: "Erreur " + err.status, detail: err.message });
          this.share.showprogressbar = false;
        }
      })
  }

  annulerUrlsPop() {
    this.editUrlsDialog = false;
    this.visiteVirtuelle = this.programmeseled.visiteVirtuelle;
    this.urlLogement = this.programmeseled.landingPage;
  }

  saveUrlsPop() {
    this.share.showprogressbar = true;
    let objUpdate = structuredClone(this.programmeseled);
    objUpdate.visiteVirtuelle = this.visiteVirtuelle;
    objUpdate.landingPage = this.urlLogement;
    this.pitService.updateUrls(objUpdate).subscribe(
      {
        next: (res) => {
          this.messageService.add({ severity: "success", summary: "Urls ", detail: "Modification avec succès" });
          this.programmeseled = res;
          this.share.showprogressbar = false;
          this.editUrlsDialog = false;
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: "Erreur " + err.status, detail: err.message });
          this.share.showprogressbar = false;
        },
      })
  }

}


